import React from "react";

import _ from 'lodash';
import cx from 'classnames';
import { getStyles } from "../card";

import {
  BASIC_TEXT, TEXT, IMAGE, VIDEO, BUTTON, SHAPE, LINE, RECTANGLE
} from '../../../../constants/widgetTypes';

import { useContainerSelector, useWidgetChildrenSelector } from "../../core/hooks";
import { getStylesForLayout } from "../../widget.helper";

import { BackgroundView } from '../../background';
import { ShapeWidget } from "../../shape";
import { LineWidget } from "../../line";
import { RectangleWidget } from "../../rectangle";

import styles from "./placeholder.module.scss";

const PlaceholderCardWidget = React.memo(function PlaceholderCardWidget({ className, style, widgetProps, breakpoint, children }) {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const background = _.get(widgetProps, `properties.desktop.background`);

  const widgetChildren = useWidgetChildrenSelector(id);

  const widgetStyles = {
    ...style,
    ...getStyles(widgetProps, breakpoint)
  }

  var children = widgetChildren.map(item => {
    return <PlaceholderWidget key={item.uid} widgetProps={item} breakpoint={breakpoint} />
  });

  return (
    <div className={styles.card} style={widgetStyles}>
      <BackgroundView background={background} breakpoint={breakpoint} />
      {children}
    </div>
  );
});

const PlaceholderWidget = ({ widgetProps, breakpoint, ...rest }) => {
  const id = _.get(widgetProps, 'uid');
  const container = useContainerSelector(id);
  const widgetChildren = useWidgetChildrenSelector(id);

  const type = _.get(widgetProps, 'type');
  const Component = getWidgetComponentFotType(type);

  if (!Component) {
    console.warn(`Component not found for type ${type}`);
    return false;
  }

  const layout = _.get(widgetProps, `properties.${breakpoint}.layout`);
  var widgetStyle = getStylesForLayout(layout, breakpoint, container);

  var children = widgetChildren.map(item => {
    return <PlaceholderWidget key={item.uid} widgetProps={item} breakpoint={breakpoint} />
  });

  return React.createElement(Component, {
    widgetProps: widgetProps,
    className: styles.placeholder,
    key: id,
    breakpoint: breakpoint,
    style: widgetStyle,
    ...rest
  }, children);
}

const getWidgetComponentFotType = (type) => {

  switch (type) {
    case BASIC_TEXT:
    case TEXT:
      return PlaceholderTextWidget;
    case IMAGE:
    case VIDEO:
    case BUTTON:
      return PlaceholderDefaultWidget;
    case SHAPE:
      return ShapeWidget;
    case RECTANGLE:
      return RectangleWidget
    case LINE:
      return LineWidget;
    default:
      return false
  }
}

const PlaceholderDefaultWidget = ({className, style}) => {
  return (
    <div className={cx(className, styles.default)} style={style}></div>
  );
}

const PlaceholderTextWidget = ({className, widgetProps, style, breakpoint}) => {

  const lineHeight = _.get(widgetProps, `properties.${breakpoint}.lineSpacing`, 1.2);
  const fontSize = _.get(widgetProps, `properties.${breakpoint}.fontSize`, 16);


  var height = _.get(widgetProps, `properties.${breakpoint}.layout.height`);
  height = parseInt(height);

  const textHeight = lineHeight * fontSize;
  height = Math.max(height, textHeight);

  const lines = Math.floor(height / textHeight);

  const textStyle = getTextStyles(widgetProps, breakpoint);

  return (
    <div className={cx(className, styles.text)} style={style}>
      {_.times(lines).map(index => {
        return <span key={index} style={textStyle}>&nbsp;</span>
      })}
    </div>
  );
}

const getTextStyles = (widget, breakpoint) => {
  const textStyle = {};

  const backgroundRgb = _.get(widget, `properties.${breakpoint}.background`, null);
  var background = '#333';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  textStyle['backgroundColor'] = background;

  const fontSize = _.get(widget, `properties.${breakpoint}.fontSize`, 16);
  textStyle['height'] = `${fontSize}px`;

  return textStyle;
}

export { PlaceholderCardWidget };
